export default __webpack_public_path__ + "static/media/sensitive.0f1bd2cf.png";